import { Component, OnInit, ViewChild, EventEmitter, AfterViewInit, OnDestroy } from "@angular/core";
import { CclMessageService, CclNotifyService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { CalendarComponent } from "ng-fullcalendar";
import { Options } from "fullcalendar";
import { Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import * as moment from 'moment';
import 'moment-timezone';
@Component({
    selector: "myschedule-section",
    templateUrl: "./myschedule-section.view.html",
    providers: []
})
export class MyscheduleSectionView implements OnInit, OnDestroy {
    private subscription: Subscription;
    selectedTab = "registered";
    mysessionConfig: any;
    myscheduleConfig: any;
    generalSessionConfig: any;
    eventDetail: any;
    isHidden: boolean = false;
    @ViewChild("mySchedule") fullcalendar: CalendarComponent;
    options: Options;
    eventsModel: any;
    statusMap: any = {
        1: "Registered",
        2: "Cancelled",
        3: "No Show",
        4: "Attended",
        5: "Waitlisted"
    };
    filterConfig: any;
    constructor(
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private attendeeSessionService: AttendeeSessionService,
        private _flashMessagesService: FlashMessagesService,
        private notifyService: CclNotifyService
    ) {
        this.subscription = this.messageService.getMessage().subscribe((message) => this.listenMessage(message));
    }

    ngOnInit() {
        $("#datePicker > .c-date-picker__input-region > input").attr("style", "display:none");
        $("#datePicker > .c-date-picker__input-region > span").attr("style", "display:none");
        this.mysessionConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config);
        this.generalSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SESSION.general].config
        );

        this.filterConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
        );
        if(!('selectTimezone' in this.filterConfig)) {
            this.filterConfig.selectTimezone = 'browser_timezone';
        }

        if (this.sharedService.event.eventDelivery === 'In Person' && this.filterConfig.isDefaultTimezone == true) {
            this.filterConfig.selectTimezone = 'event_timezone';
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    listenMessage(message) {
        if (message.text == "update-my-schedule") {
            var filter = {
                eventId: this.sharedService.event.id,
                isPublished: true,
                limit: 9999,
                mySessions: true,
                page: 0,
                registrationUUID: this.sharedService.loggedInAttendee.uuid
            };

            let registeredColor = "#2fb36d";
            let waitlistedColor = "#FA8A3B";

            if (this.generalSessionConfig.catalogConfig.buttonConfig != null) {
                registeredColor = this.sharedService.isEmptyString(
                    this.generalSessionConfig.catalogConfig.buttonConfig.regBackground
                )
                    ? registeredColor
                    : this.generalSessionConfig.catalogConfig.buttonConfig.regBackground;
                waitlistedColor = this.sharedService.isEmptyString(
                    this.generalSessionConfig.catalogConfig.buttonConfig.waitBackground
                )
                    ? waitlistedColor
                    : this.generalSessionConfig.catalogConfig.buttonConfig.waitBackground;
            }
            this.attendeeSessionService
                .getMyScheduledSessions(this.sharedService.loggedInAttendee.uuid, filter)
                .subscribe((resp) => {
                    var events = [];
                    var initStartDate = new Date();
                    if (resp.body != null && resp.body["sessions"].length > 0) {
                        this.sharedService.updateDateTime(resp.body["sessions"], this.filterConfig.selectTimezone);
                        resp.body["sessions"].forEach((session, index) => {
                            if (index == 0) {
                                initStartDate = new Date(session.startTime.replace(new RegExp(" ", "g"), "T"));
                            }
                            let result = ''
                            if(session.regWebinar !=null && session.regWebinar.participantJoinUrl !=null) {
                                result = ''
                            } else if(session.locationName != null) {
                                if(!this.mysessionConfig.my_schedule) {
                                    if(!this.mysessionConfig.calenderConfig) {
                                    result = " (" + session.locationName + ")"
                                    } else if(this.mysessionConfig.calenderConfig && this.mysessionConfig.calenderConfig.showLocation == true) {
                                    result = " (" + session.locationName + ")"
                                    }
                                } else if((this.mysessionConfig.my_schedule && this.mysessionConfig.my_schedule.calenderConfig && this.mysessionConfig.my_schedule.calenderConfig.showLocation == true)) {
                                    result = " (" + session.locationName + ")"
                                }
                                
                            }

                            if(!this.sharedService.isEmptyString(session.sessionRecurrence)) {
                                var recurrenceJSON = JSON.parse(session.sessionRecurrence);
                                let cronDisplayText = recurrenceJSON.cronDisplayText;
                                session.recurringSessionFrequency = cronDisplayText;
                                // result += " - " + cronDisplayText; 
                            }
                            
                            let speakerName = ''
                            if(session.speakers !=null && session.speakers.length>0 && this.mysessionConfig.my_schedule && this.mysessionConfig.my_schedule.calenderConfig && this.mysessionConfig.my_schedule.calenderConfig.showSpeakers == true) {
                                session.speakers.forEach((element,i) => { 
                                    if(i < session.speakers.length-1 ) {
                                        speakerName = speakerName + element.speakerFirstName + ' ' +  element.speakerLastName + ', '
                                    } else {
                                        speakerName = speakerName + element.speakerFirstName + ' ' +  element.speakerLastName
                                    }
                                });
                            }
                            
                            events.push({
                                title:
                                    `${session.sessionTitle} ${result}`,
                                status: this.statusMap[session.registrationSessionStatusId],
                                speakersName: speakerName,
                                location: session.locationName,
                                joinurl: (session.regWebinar !=null && session.regWebinar.participantJoinUrl !=null) ? session.regWebinar.participantJoinUrl : "",
                                url: (session.regWebinar !=null && session.regWebinar.participantJoinUrl !=null) ? 'javascript:void(0)' : "",
                                start: session.startTime,
                                end: session.endTime,
                                backgroundColor: session.isEnrolled
                                    ? session.registrationSessionStatusId == 1 ||
                                      session.registrationSessionStatusId == 4
                                        ? registeredColor
                                        : "#9B9B9B"
                                    : waitlistedColor,
                                textColor: "#ffffff"
                            });
                        });
                    }
                    this.options = {
                        now: new Date(),
                        editable: false,
                        events: events,
                        height: "auto",
                        customButtons: {
                            calendarButton: {
                                text: "",
                                click: function($event) {
                                    $("#datePicker > .c-date-picker__input-region > input").click();
                                    $("ccl-date-picker").attr("style", "display:block");
                                    $("#datePicker > .c-date-picker__input-region > input").attr(
                                        "style",
                                        "display:none"
                                    );
                                    $("#datePicker > .c-date-picker__input-region > span").attr(
                                        "style",
                                        "display:none"
                                    );
                                    setTimeout(() => {
                                        $("ngx-my-date-picker > div > div").attr(
                                            "style",
                                            "top:83px;left:175px;width: 252px;height: 232px;"
                                        )},
                                        0
                                    );
                                },
                                icon: "a fa fa-calendar textGreen"
                            }
                        },
                        header: {
                            left: "prev,next today calendarButton",
                            center: "title",
                            right: "listMonth,agendaDay,agendaWeek"
                        },
                        defaultView: "listMonth",
                        defaultDate: initStartDate
                    };
                    this.sharedService.showMyScheduleCalendar = true;
                });
        } else if(message.text == "apply-my-timezone") {
            this.filterConfig.selectTimezone = 'browser_timezone';
        }
    }

    eventClick(model) {
        if(model.event.joinurl) {
            window.open(model.event.joinurl, "_blank");
        }
      }

    eventrender(event, element) {
        var scrollDown = false;
        if (event.element[0].querySelectorAll(".fc-list-item-title")[0] != null) {
            event.element[0].querySelectorAll(".fc-list-item-title")[0].innerHTML += `<br><span class="fc-speaker-content"> ${event.event.speakersName} </span>`;
        }
        
        if (event.element[0].querySelectorAll(".fc-event-dot")[0] != null) {
            event.element[0].querySelectorAll(".fc-event-dot")[0].addEventListener("mouseover", (ev) => {
                var eventTemplate = "<span>" + event.event.status + "</span>";
                this.eventDetail = eventTemplate;
                this.isHidden = true;
                $(".my-schedule-tab-content").bind("scroll", function() {
                    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 50) {
                        scrollDown = true;
                    } else {
                        scrollDown = false;
                    }
                });

                setTimeout(() => {
                    if (document.getElementById("tool-tip-event") != null) {
                        document.getElementById("tool-tip-event").classList.remove("visible-hide");
                        document.getElementById("tool-tip-event").classList.add("tool-tip-event-align");
                        if (scrollDown) {
                            document.getElementById("tool-tip-event").style.top = ev.clientY - 100 + "px";
                        } else {
                            document.getElementById("tool-tip-event").style.top = ev.clientY + 20 + "px";
                        }
                        document.getElementById("tool-tip-event").style.left = ev.clientX / 2 - 140 + "px";
                    }
                }, 0);
            });
            event.element[0].querySelectorAll(".fc-event-dot")[0].addEventListener("mouseout", (e) => {
                document.getElementById("tool-tip-event").classList.remove("tool-tip-event-align");
                document.getElementById("tool-tip-event").classList.add("visible-hide");
                this.isHidden = false;
            });
        }

        if (event.element[0].querySelectorAll(".fc-content")[0] != null) {
            event.element[0].querySelectorAll(".fc-content")[0].addEventListener("mouseover", (ev) => {
                var eventTemplate =
                    "<span>" + event.event.title + '</span></br><span class="fs-12" >' + event.event.status + "</span><br><span class='fc-speaker-content'>"  + event.event.speakersName + "</span>";
                this.eventDetail = eventTemplate;
                this.isHidden = true;
                $(".my-schedule-tab-content").bind("scroll", function() {
                    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 50) {
                        scrollDown = true;
                    } else {
                        scrollDown = false;
                    }
                });

                setTimeout(() => {
                    if (document.getElementById("tool-tip-event") != null) {
                        document.getElementById("tool-tip-event").classList.remove("visible-hide");
                        document.getElementById("tool-tip-event").classList.add("tool-tip-event-align");
                        if (scrollDown) {
                            document.getElementById("tool-tip-event").style.top = ev.clientY - 100 + "px";
                        } else {
                            document.getElementById("tool-tip-event").style.top = ev.clientY + 20 + "px";
                        }
                        document.getElementById("tool-tip-event").style.left = ev.clientX / 2 - 140 + "px";
                    }
                }, 0);
            });
            event.element[0].querySelectorAll(".fc-content")[0].addEventListener("mouseout", (e) => {
                document.getElementById("tool-tip-event").classList.remove("tool-tip-event-align");
                document.getElementById("tool-tip-event").classList.add("visible-hide");
                this.isHidden = false;
            });
        }
    }

    changeCalendarDate($event) {
        $event.date.date.month = $event.date.date.month - 1;
        this.fullcalendar.fullCalendar("gotoDate", $event.date.date);
    }

    closeMySchedule() {
        this.messageService.sendMessage("toggle-myschedule");
    }

    downloadMySessionCalendar() {
        var filter = {
            eventId: this.sharedService.event.id,
            isPublished: true,
            limit: 9999,
            mySessions: true,
            page: 0
        };

        this.attendeeSessionService
            .downloadMySessionsCalendar(this.sharedService.loggedInAttendee.uuid, filter)
            .subscribe((resp) => {
                FileSaver.saveAs(resp.body, "Calendar.ics");
            });

    }
}
